import {
  APP_ID_ADEM_AIOPS,
  APP_ID_AI_OPS,
  APP_ID_AUTONOMOUS_DEM,
  APP_ID_AUTONOMOUS_DEM_MOBILE,
  APP_ID_AUTONOMOUS_DEM_REMOTE_NETWORKS,
  APP_ID_CASB,
  APP_ID_CUSTOMER_SUCCESS,
  APP_ID_DATA_TRANSFER,
  APP_ID_DLP,
  APP_ID_DSS_ID,
  APP_ID_DVR,
  APP_ID_FEDRAMP,
  APP_ID_IOT,
  APP_ID_LOGGING_SERVICE,
  APP_ID_NET_INTER_CONNECT,
  APP_ID_OKYO,
  APP_ID_PAN_CHINA,
  APP_ID_PANORAMA,
  APP_ID_PRISMA_ACCESS,
  APP_ID_PRISMA_ACCESS_EDITION,
  APP_ID_PRISMA_ACCESS_MOBILE_USERS,
  APP_ID_PRISMA_ACCESS_ONPERM,
  APP_ID_PRISMA_ACCESS_PANORAMA,
  APP_ID_PRISMA_ACCESS_REMOTE_NETWORKS,
  APP_ID_PRISMA_SAAS,
  APP_ID_PRIVATE_APPS,
  APP_ID_PRIVATE_APPS_QTY,
  APP_ID_SDWAN,
  APP_ID_SERVICE_CONNECTION,
  APP_ID_SERVICE_LOC,
  APP_ID_SUPPORT,
  APP_ID_ZTNA,
  APP_ID_NG_CASB,
  APP_ID_BACKBONE,
  APP_ID_COLO_CONNECT,
  APP_ID_TRAFFIC_MIRRORING,
  APP_ID_STRATA_INSIGHTS,
  APP_ID_EMAIL_DLP
} from './GlobalConstants'

/******************************************
 *  Author : vsuthar
 *  Created On : Thu Sep 02 2021
 *  File : LabelConstants.js
 *  ©Palo Alto Networks
 *******************************************/


export const TAB_TENANT_MANAGEMENT = 'Tenant Management'
export const TAB_IAM_MANAGEMENT = 'Identity & Access / Access Management'
export const TAB_IAM_ROLES = 'Identity & Access / Roles'
export const TAB_IAM_FEDERATIONS = 'Identity & Access / Identity Federations'
export const TAB_IP_ALLOW = 'Trusted IP List'
export const TAB_DEVICE_ASSOCIATIONS = 'Device Associations'
export const TAB_SUBSCRIPTIONS_MANAGEMENT = 'Subscriptions & Add-ons'
export const SEARCH_TENANTS = 'Search Tenant Name or ID'
export const IAM_SELECT_MANAGEMENT = 'Access Management'
export const IAM_SELECT_ROLES = 'Roles'
export const IAM_SELECT_FEDERATIONS = 'Identity Federations'

/**
 * BUTTONS LABELS
 */

export const BUTTON_CANCEL = 'Cancel'
export const BUTTON_ADD_TENANT = 'Add Tenant'
export const BUTTON_CLOSE = 'Close'
export const BUTTON_ADD_IDENTITY_FEDERATION = 'Add Identity Federation'
export const BUTTON_DONE = 'Done'


/**
 * LABELS
 */

export const LABEL_NONE = 'None'
export const LABEL_NOT_APPLICABLE = 'Not Applicable'
export const LABEL_TSG_ID = 'TSG ID: {0}'
export const LABEL_SUPPORT_CONTACT = 'Support Contact'
export const LABEL_TSG_NAME = 'Name: {0}'
export const LABEL_PANORAMA = 'Panorama'
export const LABEL_NO_ACCESS = 'Access Denied'
export const LABEL_NO_ACCESS_DESCRIPTION = 'You do not have access to common services on the TSG you selected.'
export const LABEL_VIEWING = 'Currently Viewing'

/**
 * ERRORS
 */
export const ERROR_PERSONAL_EMAIL = 'Email {0} is not an enterprise email'
export const ERROR_FEDERATION_MAPPING_ERROR = 'An error occurred while updating the Federation Mapping'
export const ERROR_FEDERATION_MAPPING_ACCESS_DENIED = 'You do not have access to create a mapping for {0}'

export const ERROR_ACCESS_DENIED = 'Access denied. Please contact your system administrator.'

/**
 * TOOL-TIP
 */


/**
 * Tenant Switcher
 */

export const MANAGE_USER_AND_ROLE = 'Identity & Access'
export const MANAGE_SUBSCRIPTIONS = 'Subscriptions & Add-ons'
export const MANAGE_LICENSE = 'Tenant Management'
export const HUB = 'Hub'
export const ASC = 'ASC Partner Portal'
export const MANAGE_DEVICE_ASSOCIATIONS = 'Device Associations'
export const SWITCH_MULTI_TENANT_PORTAL = 'Prisma SASE Multitenant Portal'
export const MANAGE_IP_ALLOW_LIST = 'Trusted IP List'

/**
 * Application app_id and Label constants
 */

export const LOGGING_SERVICE = 'Cortex Data Lake'
export const PRISMA_ACCESS = 'Prisma Access'
export const CIE = 'Cloud Identity Engine'
export const PRISMA_SAAS_DISPLAY_NAME = 'Prisma SaaS'
export const PRISMA_ACCESS_EDITION = 'Prisma Access Edition'
export const NET_INTER_CONNECT = 'Net Inter Connect'
export const PRIVATE_APPS = 'Service Connection'
export const PRIVATE_APPS_QTY = 'Additional Service Connection'
export const DATA_TRANSFER = 'Data Transfer'
export const PRISMA_ACCESS_MOBILE = 'Prisma Access Mobile'
export const DLP = 'DLP'
export const IOT = 'IoT'
export const AUTONOMOUS_DEM = 'Autonomous DEM'
export const AUTONOMOUS_DEM_REMOTE = 'Autonomous DEM Remote'
export const AUTONOMOUS_DEM_MOBILE = 'Autonomous DEM Mobile'
export const CUSTOMER_SUCCESS = 'Customer Success'
export const SERVICE_CONNECTION = 'Service Connection'
export const PRISMA_SDWAN = 'Prisma SD-WAN'
export const DVR = 'Dvr'
export const PRISMA_ACCESS_REMOTE = 'Prisma Access Remote'
export const OKYO = 'Okyo'
export const PANOROMA = 'Panoroma'
export const SUPPORT = 'Support'
export const CASB = 'CASB'
export const SERVICE_LOCATION = 'Additional Location'
export const PAN_CHINA = 'Prisma Access China'
export const FEDRAMP = 'Fedramp'
export const AI_OPS = 'AI powered ADEM'
export const ZTNA = 'Prisma Access ZTNA'
export const COLO_CONNECT = 'Colo-Connect'
export const TRAFFIC_MIRRORING = 'Traffic Replication'
export const STRATA_INSIGHTS = 'AIOPS Premium'
export const EMAIL_DLP = 'Email DLP'


/**
 * Application app_id and App Label Mapping
 * @type {{[p: string]: string, "[APP_ID_IOT]": string, "[APP_ID_PRISMA_ACCESS]": string, "[APP_ID_AUTONOMOUS_DEM]": string, "[APP_ID_DLP]": string, "[APP_ID_PRIVATE_APPS]": string, "[APP_ID_CUSTOMER_SUCCESS]": string, "[APP_ID_PRISMA_ACCESS_EDITION]": string, "[APP_ID_DATA_TRANSFER]": string, "[APP_ID_LOGGING_SERVICE]": string, "[APP_ID_PRISMA_SAAS]": string, "[APP_ID_NET_INTER_CONNECT]": string, "[APP_ID_DSS_ID]": string, "[APP_ID_PRIVATE_APPS_QTY]": string}}
 */
// TODO: REMOVE THIS, DON'T USE THIS, USE APP REGISTRY
export const APP_ID_TO_NAME = {
  [APP_ID_LOGGING_SERVICE]: LOGGING_SERVICE,
  [APP_ID_PRISMA_ACCESS]: PRISMA_ACCESS,
  [APP_ID_DSS_ID]: CIE,
  [APP_ID_PRISMA_SAAS]: PRISMA_SAAS_DISPLAY_NAME,
  [APP_ID_PRISMA_ACCESS_EDITION]: PRISMA_ACCESS_EDITION,
  [APP_ID_NET_INTER_CONNECT]: NET_INTER_CONNECT,
  [APP_ID_PRIVATE_APPS]: PRIVATE_APPS,
  [APP_ID_PRIVATE_APPS_QTY]: PRIVATE_APPS_QTY,
  [APP_ID_DATA_TRANSFER]: DATA_TRANSFER,
  [APP_ID_DLP]: DLP,
  [APP_ID_AUTONOMOUS_DEM]: AUTONOMOUS_DEM,
  [APP_ID_AUTONOMOUS_DEM_MOBILE]: AUTONOMOUS_DEM_MOBILE,
  [APP_ID_AUTONOMOUS_DEM_REMOTE_NETWORKS]: AUTONOMOUS_DEM_REMOTE,
  [APP_ID_IOT]: IOT,
  [APP_ID_CUSTOMER_SUCCESS]: CUSTOMER_SUCCESS,
  [APP_ID_PRISMA_ACCESS_ONPERM]: PRISMA_ACCESS,
  [APP_ID_PRISMA_ACCESS_PANORAMA]: PRISMA_ACCESS,
  [APP_ID_PRISMA_ACCESS_MOBILE_USERS]: PRISMA_ACCESS_MOBILE,
  [APP_ID_SERVICE_CONNECTION]: SERVICE_CONNECTION,
  [APP_ID_SDWAN]: PRISMA_SDWAN,
  [APP_ID_DVR]: DVR,
  [APP_ID_PRISMA_ACCESS_REMOTE_NETWORKS]: PRISMA_ACCESS_REMOTE,
  [APP_ID_OKYO]: OKYO,
  [APP_ID_PANORAMA]: PANOROMA,
  [APP_ID_SUPPORT]: SUPPORT,
  [APP_ID_CASB]: CASB,
  [APP_ID_SERVICE_LOC]: SERVICE_LOCATION,
  [APP_ID_AI_OPS]: AI_OPS,
  [APP_ID_PAN_CHINA]: PAN_CHINA,
  [APP_ID_FEDRAMP]: FEDRAMP,
  [APP_ID_ADEM_AIOPS]: AI_OPS,
  [APP_ID_ZTNA]: ZTNA,
  [APP_ID_COLO_CONNECT]: COLO_CONNECT,
  [APP_ID_TRAFFIC_MIRRORING]: TRAFFIC_MIRRORING,
  [APP_ID_STRATA_INSIGHTS]: STRATA_INSIGHTS,
  [APP_ID_EMAIL_DLP]: EMAIL_DLP,
}

export const APP_TO_ALIAS = {
  [APP_ID_LOGGING_SERVICE]: 'Data Space',
}

export const APP_ID_TO_UNIT = {
  [APP_ID_LOGGING_SERVICE]: 'TB',
  [APP_ID_PRISMA_ACCESS_MOBILE_USERS]: 'Users',
  [APP_ID_PRISMA_ACCESS_REMOTE_NETWORKS]: 'Mbps',
  [APP_ID_BACKBONE]: 'Connections',
  [APP_ID_NG_CASB]: 'Users',
  [APP_ID_EMAIL_DLP]: 'Users'
}

export const DO_NOT_RENDER_UNITS = new Set([APP_ID_DLP, APP_ID_PRISMA_SAAS, APP_ID_PAN_CHINA, APP_ID_FEDRAMP])
export const DO_NOT_RENDER_DUPLICATES = new Set([APP_ID_DLP, APP_ID_PRISMA_SAAS])
export const DO_NOT_DISPLAY_ADDONS = new Set([APP_ID_PAN_CHINA, APP_ID_FEDRAMP])
export const BUNDLED_PRODUCTS = new Set([APP_ID_NG_CASB])

export const APP_UNITS = {
  'Remote Network': 'Mbps',
  'Mobile Users': 'Users'
}
export const APP_ID_TO_UNIT_DESC = {
  [APP_ID_LOGGING_SERVICE]: 'Maximum $ TB remaining',
  [APP_ID_PRISMA_ACCESS_MOBILE_USERS]: 'Maximum $ Users remaining',
  [APP_ID_PRISMA_ACCESS_REMOTE_NETWORKS]: 'Maximum $ Mbps remaining',
  [APP_ID_SERVICE_LOC]: 'The contract includes $ locations',
  [APP_ID_PRIVATE_APPS_QTY]: 'The contract includes $ Service Connections'
}

export const ERROR_NO_CDL_CSP_ACCESS = 'User does not have access to the customer support acount {0}.'
export const ERROR_NO_TSG_INSTANCE_CSP_ACCESS = 'User does not have access the customer support acount {0}.'
export const ERROR_NO_RESTRICTED_CSP_ACCESS = 'User does not have access to any of the restricted support accounts.'
export const ERROR_NO_CSP_ACCESS = 'User does not have access to any of the customer support accounts.'
export const ERROR_NO_CDL_INSTANCE = 'No Cortex Data Lake instance found in the TSG'
export const ERROR_NO_CDL_INSTANCE_IN_RESTRICTED_ACCOUNTS = 'No Cortex Data Lake instance found in restricted support accounts.'
export const ERROR_NO_CDL_INSTANCE_CSP = 'No Cortex Data Lake instance found in the customer support account.'

export const CHINA_HEADER = ' - China'

export const ELA_LICENSE_MESSAGE = 'You are activating under ELA licenses.'

export const ZTP_ERROR_AND_MESSAGES: { [index: string]: string } = {
  '2451': 'Invalid claim key for device',
  '2027': 'The device with serial number was not found',
  '2452': 'The device already has a support account associated',
  '2453': 'Support account with ID not found',
  'DEVICE_INVENTORY_1006': 'Device not found',
  'DEVICE_INVENTORY_1010': 'Device already exists',
  'DEVICE_INVENTORY_1011': 'Failed to create device'
}

export const LABEL_PRODUCT_IS_IP_RESTRICTED = 'The content you are trying to access is limited to specific IP addresses for this tenant. Seems like your IP address is not on the list.'
export const LABEL_CONTACT_SUPPORT_ADMIN = 'Please reach out to your system admin for support or alternatively'
export const LABEL_TENANT_SWITCHER_IP_RESTRICTED = 'Current IP address denied access to data'
export const HEADING_ACCESS_DENIED = 'Access denied'
export const LABEL_NO_INSTANCE_FOUND = 'No Instance Found'
export const LABEL_NO_ACCESS_RESET_DESC = 'Go to {0} -> Common Services -> Trusted IP List to resolve the issue.'
export const TITLE_FEATURE_NOT_SUPPORTED = 'Feature not supported'
export const SUBTITLE_FEATURE_NOT_SUPPORTED = 'This feature is not supported for this tenant'
